import { useI18n } from '@app-velocity/i18n';
import { EditIcon } from '@app-velocity/icons';
import { MessageBus } from '@app-velocity/message-bus';
import { Button } from '@app-velocity/ui';

const messageBus = new MessageBus('prototypes');

export type RenameFigmaReportButtonProps = {
  id: string;
  displayName: string;
  workspaceId: string;
};

export const RenameFigmaReportButton = ({
  id,
  displayName,
  workspaceId,
}: RenameFigmaReportButtonProps) => {
  const { t } = useI18n();

  const onClick = () => {
    messageBus.publish('modal:rename-figma-report:open', {
      id,
      displayName,
      workspaceId,
    });
  };

  return (
    <Button variant="reportAction" color="default" onClick={onClick}>
      <EditIcon />
      {t('shared:rename')}
    </Button>
  );
};
